import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "df-outer" }

import DesktopSearchBar from "@/vue/planning/components/search/DesktopSearchBar.vue";
import { useStore } from 'vuex'

export default /*@__PURE__*/_defineComponent({
  __name: 'DataFilter',
  setup(__props) {

const store = useStore()


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(DesktopSearchBar)
  ]))
}
}

})